import Vue from 'vue';
import Store from '../../lib/stores/store';
import Instance from './instance.html';
import BookingDetail from './booking-detail';

if (document.getElementById('bookingDetail')) {
	const vue = new Vue({
		el: '#bookingDetail',
		store: Store,
		template: Instance,
		components: {
			BookingDetail,
		},
	});
}
